<template>
  <!-- producto -->
    <div class="producto_admin">
      <div class="imagen">
        <img
          src="https://cdn.shopify.com/s/files/1/0654/1837/products/ashbrown-front-boogatti_2x_146b13c9-9047-4a28-8b68-df893f7fb86f_1024x1024.jpg?v=1557028427"
          alt
        />
      </div>
      <div class="info">
        <div class="cat">
          <span>Extensiones largas</span>
        </div>
        <div class="nombre">
          <span>20" INCHES / 120 GRAMS Chocolate Brown</span>
        </div>
        <div class="precio">
          <span>$2500 <span class="small">pesos</span></span>
        </div>
        <div class="button">
            <router-link to="/producto" ><span class="btn">AGREGAR PRODUCTO</span></router-link>
          
        </div>
      </div>
    </div>
  <!-- /producto -->
</template>

<script>
export default {
  name: "Producto",

  data: () => {
    return {
      scrollPosition: null
    };
  }
};
</script>

